import styled from '@emotion/styled';
import { Loader, tokens } from '@hotjar/hotsauce';
import React from 'react';
import { SignUpHeader } from '@hotjar/webapp/components/SignUpHeader';
import traceLineImage from '@hotjar/webapp/images/landing/traceline.png';

const colorMap = {
  COBALT_100: tokens.BRAND_COLORS.cobalt_100,
};

interface LandingWrapperProps {
  isLoading?: boolean;
  children: React.ReactNode;
  user?: React.ComponentProps<typeof SignUpHeader>['user'];
  background?: keyof typeof colorMap;
  isTraceLineActive?: boolean;
}

const Wrapper = styled.div<{ bgColor?: keyof typeof colorMap }>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100vh;

  background-color: ${(props) => (props.bgColor ? colorMap[props.bgColor] : 'transparent')};
`;

const StyledLoader = styled(Loader)`
  margin: auto;
`;

const ColWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 0 ${tokens.spacer.x2};
  margin: 0 auto;
  z-index: 2;
`;

const Row = styled.div`
  margin: 0 auto;
`;

const HeaderWrapper = styled.div`
  border-bottom: 1px solid ${tokens.color.ui_border_light};
`;

const TraceLine = styled.img`
  position: absolute;
  width: 330px;
  height: 496px;
  left: 0;
  bottom: 0;
  z-index: 1;
`;

export const LandingLayout = ({
  isLoading = false,
  children,
  user,
  background,
  isTraceLineActive,
}: LandingWrapperProps): JSX.Element => {
  return (
    <Wrapper bgColor={background}>
      <>
        {isLoading ? (
          <StyledLoader size="xl" />
        ) : (
          <>
            <HeaderWrapper>
              <SignUpHeader user={user} />
            </HeaderWrapper>
            <ColWrapper>
              <Row>{children}</Row>
            </ColWrapper>
          </>
        )}
        {isTraceLineActive && <TraceLine src={traceLineImage} alt="Trace line" />}
      </>
    </Wrapper>
  );
};
